import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, onMounted, ref } from "vue";
import Decimal from "decimal.js";

export default /*#__PURE__*/_defineComponent({
  __name: 'ShopPoints',
  props: {
    points: { default: 0 }
  },
  setup(__props: any) {

const props = __props;



const points = computed(() => {
  return new Decimal(props.points).div(10000).toFixed(2);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", null, _toDisplayString(points.value), 1))
}
}

})